import { useState } from 'react';

import { imagesApi } from '../../api';
import { Modal } from '../common';
import './chat.css';

/**
 * A message attachment, with an original ⇄ model-view toggle.
 *
 * The model view is the bottom-anchored crop the model actually receives. Making
 * it one click away is the difference between "the model missed the sidewalk" and
 * "the crop removed the sidewalk" — two very different bugs that look identical
 * until you can see both frames.
 */
export function ImageThumb({ image, versionId, caption }) {
  const [open, setOpen] = useState(false);
  const [modelView, setModelView] = useState(false);

  const source = modelView
    ? imagesApi.modelViewUrl(image.id, versionId)
    : imagesApi.fileUrl(image.id, { thumb: true });

  return (
    <>
      <button type="button" className="thumb" onClick={() => setOpen(true)} title="Open larger">
        <img
          src={imagesApi.fileUrl(image.id, { thumb: true })}
          alt={image.filename || 'Road image'}
        />
        <span className="thumb__meta">
          <span>{image.filename || image.id.slice(0, 8)}</span>
          {image.width ? (
            <span>
              {image.width}×{image.height}
            </span>
          ) : null}
        </span>
      </button>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        title={image.filename || 'Image'}
        subtitle={
          modelView
            ? 'Model view — cover-resized and bottom-anchored crop, exactly what the model receives'
            : `Original upload${image.width ? ` · ${image.width}×${image.height}` : ''}`
        }
        wide
        footer={
          <div className="row grow">
            <button
              type="button"
              className={`chip chip--button ${modelView ? '' : 'chip--accent'}`}
              onClick={() => setModelView(false)}
            >
              Original
            </button>
            <button
              type="button"
              className={`chip chip--button ${modelView ? 'chip--accent' : ''}`}
              onClick={() => setModelView(true)}
            >
              Model view
            </button>
            {caption && (
              <span className="xs subtle" style={{ marginLeft: 'auto' }}>
                {caption}
              </span>
            )}
          </div>
        }
      >
        <img
          src={
            modelView ? imagesApi.modelViewUrl(image.id, versionId) : imagesApi.fileUrl(image.id)
          }
          alt={image.filename || 'Road image'}
          style={{ width: '100%', borderRadius: 'var(--radius)', display: 'block' }}
        />
        <div className="xs subtle" style={{ marginTop: 10 }}>
          {modelView
            ? 'If a feature you are asking about is missing from this frame, the model never saw it — adjust the version’s input size or crop anchor in its metadata.'
            : 'Switch to the model view to see the crop the model was given.'}
        </div>
        <img src={source} alt="" style={{ display: 'none' }} />
      </Modal>
    </>
  );
}
